Revolution.Module.extend({
    NAME: "mde.bk-card-views", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {

        if ($(window).width() < 960) {
            $('.change-view-buttons .js-toggle-list').removeClass('active');

            $('.change-view-buttons .icon-burger.js-toggle-list').addClass('active');

            $('.bk-cards-views').addClass('-large').find('li').addClass('-large');
        }
        
        $('body').on('click', '.change-view-buttons .js-toggle-list:not(".active")', this.activeCardButton);

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    activeCardButton: function (e) {
        var $selectedBtn = $(e.currentTarget);
        var $listCards = $selectedBtn.parents('.change-view-buttons').parent().siblings('.bk-cards-views');

        $selectedBtn.parents('.change-view-buttons').find('.js-toggle-list').removeClass('active');
        $selectedBtn.addClass('active');

        if ($selectedBtn.data('mode') == "large") {
            $listCards.addClass('-large').find('li .card-sm').addClass('-large');
        } else {
            $listCards.removeClass('-large').find('li .card-sm').removeClass('-large');
        }
    }
});
